<div class="" [ngClass]="{'min-[991px]:w-[80%] w-full' : showSkip, 'w-full mt-[16px] min-[991px]:mt-[52px]' : !showSkip }">
    <!-- Header -->
    <div class="mb-[17px] min-[991px]:mb-[24px]">
        <!-- Title & Skip -->
        <div class="flex items-center"
            [ngClass]="{ 'justify-between': showSkip, 'justify-start': !showSkip }">
            <h1 class="text-black text-[16px] min-[991px]:text-[32px] font-[700]">
                {{ titleKey | translate }}
            </h1>
            <button
                *ngIf="showSkip"
                type="button"
                class="skip-btn"
                [class.skip-btn-disabled]="!sharedService.doneBusinessDetailsBySkip && sharedService.businessDetails"
                [disabled]="(!sharedService.doneBusinessDetailsBySkip && sharedService.businessDetails) || skipLoading"
                [matTooltip]="isFromPrevious && sharedService.doneBusinessDetailsBySkip ? ('Done_Skip_Before' | translate) : null"
                (click)="onSkip()">
                {{ "Skip" | translate }}
                <span class="btn-spinner-icon" *ngIf="skipLoading"></span>
            </button>
        </div>

        <!-- Description -->
        <p *ngIf="descriptionKey" class="text-[#979797] font-normal text-[16px] min-[991px]:text-[20px] mt-[8px] min-[991px]:mt-[16px]">
            {{ descriptionKey | translate }}
        </p>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()">
        <!-- Business Logo Field -->
        <div class="mb-[14px] md:mb-[24px]">
            <app-upload-file
                [isRequired]="false"
                variant="business-logo"
                (getFile)="onGetFile($event)"
                (fileCleared)="onClearLogo()"
                (fileSizeError)="onFileSizeError()"
                [imageUrl]="imgSrc"
            ></app-upload-file>
        </div>

        <!-- Role Field -->
        <div  class="min-[991px]:mb-[2px] flex flex-col">
            <mat-label class="block text-[#000] text-[12px] min-[991px]:text-[16px] font-[400] min-[991px]:font-[500]">
                {{ 'Role' | translate }}
                <span class="text-[#6059a2]">*</span>
            </mat-label>
            <mat-form-field class="w-full mt-[2px] min-[991px]:mt-[8px]" appearance="outline">
                <mat-select
                    disableRipple
                    formControlName="PositionId"
                    [placeholder]="'Role' | translate">
                    <mat-option *ngFor="let position of positions" [value]="position.PositionId">
                        {{ dir == 'rtl' ? position.NameAr : position.NameEn }}
                    </mat-option>
                </mat-select>
                <mat-error>
                    <app-error-form
                        [name]="'Role' | translate"
                        [control]="form.controls['PositionId']"
                    ></app-error-form>
                </mat-error>
            </mat-form-field>
        </div>

        <!-- Phone Number Field -->
        <div class="min-[991px]:mb-[2px] flex flex-col" >
            <!-- Label -->
            <mat-label class="employee-and-branch-label mb-[8px] block text-black text-[12px] lg:text-[16px] font-normal lg:font-medium">
                {{ "Working_Phone_Number" | translate }}
                <span class="text-[#6059a2]">*</span>
            </mat-label>
            <div class="flex max-[991px]:flex-col items-start justify-start">
                <!-- Country Select -->
                <mat-form-field class="max-[991px]:w-full min-[991px]:me-[16px] country-working-phone-number" appearance="outline">
                    <mat-select
                        formControlName="CountryId"
                        [placeholder]="'Select_Country' | translate"
                        (selectionChange)="onCountryChange($event.value)">
                        <!-- Selected Value -->
                        <mat-select-trigger>
                            <ng-container *ngIf="getSelectedCountry()">
                                <div class="flex items-center">
                                    <img
                                        [src]="getSelectedCountry()?.FlagPath"
                                        width="24px"
                                        alt=""
                                        class="border border-[#ddd]"
                                    />
                                    <span class="mx-1 text-[12px] min-[991px]:text-[16px]">
                                        {{ getSelectedCountry()?.CallingCode }}
                                    </span>
                                </div>
                            </ng-container>
                        </mat-select-trigger>
                        <!-- Options -->
                        <mat-option
                            class="sign-up-country-menu-item"
                            *ngFor="let country of countries"
                            [value]="country.Id">
                            <div class="flex items-center">
                                <img
                                    [src]="country.FlagPath"
                                    width="24px"
                                    alt=""
                                    class="border border-[#ddd]"
                                />
                                <span class="text-[12px] min-[991px]:text-[16px] text-[#4D5762] mx-1">
                                    {{ country.CallingCode }}
                                </span>
                            </div>
                        </mat-option>
                    </mat-select>
                    <!-- Error -->
                    <mat-error>
                        <app-error-form
                            [name]="'Select_Country' | translate"
                            [control]="form.controls['CountryId']"
                        ></app-error-form>
                    </mat-error>
                </mat-form-field>
                <!-- Phone Input -->
                <mat-form-field class="max-[991px]:w-full min-[991px]:flex-1" appearance="outline">
                    <input
                        matInput
                        [dir]="dir"
                        type="tel"
                        formControlName="BusinessPhoneNumber"
                        [placeholder]="'ENTER_PHONE_NUMBER' | translate"
                        [maxLength]="12"
                        appNumberOnly
                    />
                    <mat-error>
                        <app-error-form
                            [name]="'Working_Phone_Number' | translate"
                            [control]="form.controls['BusinessPhoneNumber']"
                            [maxLength]="12"
                            [minLength]="4"
                        ></app-error-form>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        
        <!-- Number Of Employees & Number Of Branches -->
        <div class="mb-[16px] min-[991px]:mb-[32px] w-full max-w-full flex flex-col min-[991px]:flex-row items-start min-[991px]:items-stretch min-[991px]:justify-between gap-[14px] min-[991px]:gap-[16px]"
            [ngClass]="{'min-[991px]:!mb-[60px]' : !showActions }">
            <!-- Number Of Employees -->
            <div class="flex flex-col justify-between w-full min-w-0 min-[991px]:w-1/2 max-w-full">
                <mat-label class="employee-and-branch-label mb-[8px] block text-black text-[12px] lg:text-[16px] font-normal lg:font-medium">
                    {{ 'NumberOfEmployees' | translate }}
                    <span class="text-[#6059a2]">*</span>
                </mat-label>

                <div class="employee-and-branch-input">
                    <button type="button" class="employee-and-branch-btn employee-and-branch-minus-btn" (click)="decrement('NumberOfEmployees')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-dash-lg" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"/>
                        </svg>
                    </button>
                    <input
                        type="number"
                        class="employee-and-branch-value text-[#000]"
                        formControlName="NumberOfEmployees"
                        min="1"
                        appNumberOnly
                    />
                    <button type="button" class="employee-and-branch-btn employee-and-branch-plus-btn" (click)="increment('NumberOfEmployees')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
                        </svg>
                    </button>
                </div>
                <div class="employee-and-branch-error"
                    *ngIf="form.controls['NumberOfEmployees']?.touched || form.controls['NumberOfEmployees']?.dirty">
                    <app-error-form
                        [name]="'NumberOfEmployees' | translate"
                        [control]="form.controls['NumberOfEmployees']"
                        [min]="1"
                    ></app-error-form>
                </div>
            </div>

            <!-- Number Of Branches -->
            <div class="flex flex-col justify-between w-full min-w-0 min-[991px]:w-1/2 max-w-full">
                <mat-label class="employee-and-branch-label mb-[8px] block text-black text-[12px] lg:text-[16px] font-normal lg:font-medium">
                    {{ 'NumberOfBranches' | translate }}
                    <span class="text-[#6059a2]">*</span>
                </mat-label>

                <div class="employee-and-branch-input">
                    <button type="button" class="employee-and-branch-btn employee-and-branch-minus-btn" (click)="decrement('NumberOfBranches')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-dash-lg" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8"/>
                        </svg>
                    </button>
                    <input
                        type="number"
                        class="employee-and-branch-value text-[#000]"
                        formControlName="NumberOfBranches"
                        min="1"
                        appNumberOnly
                    />
                    <button type="button" class="employee-and-branch-btn employee-and-branch-plus-btn" (click)="increment('NumberOfBranches')">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"/>
                        </svg>
                    </button>
                </div>
                <div class="employee-and-branch-error"
                    *ngIf="form.controls['NumberOfBranches']?.touched || form.controls['NumberOfBranches']?.dirty">
                    <app-error-form
                        [name]="'NumberOfBranches' | translate"
                        [control]="form.controls['NumberOfBranches']"
                        [min]="1"
                    ></app-error-form>
                </div>
            </div>
        </div>

        <!-- Submit Button -->
        <div *ngIf="showActions" class="mb-[16px]">
            <button
                color="primary"
                type="submit"
                class="generic-submit-btn"
                [disabled]="!canSubmit || loading">
                {{ "Next" | translate }}
                <span class="btn-spinner-icon" *ngIf="loading"></span>
            </button>
        </div>
    </form>
</div>

